module.exports = __webpack_public_path__ + "img/levelup-icon-income.5c3a1f30.svg";